import { pli } from "../core/pli";


/**
 * The name of the Pli version header.
 */
export const versionHeaderConst = "X-Pli-Server-Version";


/**
 * Force-reloads current browser page if "Pli.call" response version doesn't match page version.
 *
 * No reload is triggered if the response doesn't have version info.
 *
 * @returns
 *     "true" if the current page was force-reloaded, false otherwise.
 */
export function reloadPageIfObsolete(response: any): boolean {
    if (!response) { throw new Error("Expected response object"); }

    // reload page if client version doesn't match server's one
    const serverVersion = response.clientXhr && response.clientXhr.getResponseHeader && response.clientXhr.getResponseHeader(versionHeaderConst);
    if (serverVersion && serverVersion !== pli.config.appVersion) {
        location.reload(true);
        return true;
    }
    return false;
}


/**
 * Inject "versionHeader" property to "reloadPageIfObsolete" function.
 *
 * TODO Remove in next major version.
 */
export namespace reloadPageIfObsolete {

    /**
     * Name of the Pli call response header that carries server-version information.
     */
    export const versionHeader = versionHeaderConst;

}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/util/window.ts